import React from 'react';
import * as Iconly from 'react-iconly';
import * as Icons from '../../../icons';
import {walltax} from "../../../config";
import {Avatar} from "primereact/avatar";
import {dateToPersian} from "../../../utils/functions";
import DocumentItem from "./document-item";
function AnnotationItem({note, incident}) {
    return(
        <div className="w-full ">
            <div className="flex justify-content-between align-items-center p-2">
                <div className="flex align-items-center gap-2">
                    {
                        note._createdby_value!==incident._createdby_value?(
                            <>
                                <Avatar className="bg-primary" size="large" icon={()=>{return <Icons.Support/>}}/>
                                <span className="text-sm">پاسخ پشتیبانی</span>
                            </>
                        ):(
                            <>
                                <Avatar size="large" icon="pi pi-user"/>
                                <span className="text-sm">{incident && incident["_customerid_value@OData.Community.Display.V1.FormattedValue"]}</span>
                            </>
                        )
                    }
                </div>
                <span className="text-gray-500 text-sm">{dateToPersian(note.createdon, "hh:mm YYYY/MM/DD ")}</span>
            </div>
            <div className="w-full bg-white border-round-xl shadow-2">
                <div className="p-3 line-height-4">{note.notetext}</div>
                {
                    note.isdocument && note.documentbody && (<div className="flex gap-2 p-2"><DocumentItem annotationid={note.annotationid}/></div>)
                }

            </div>

        </div>
    )
}

export default AnnotationItem;